<template>
  <div>
    <h3 class="u-mb-20">{{ id ? 'Editar nutricionista' : 'Novo nutricionista' }}</h3>

    <el-form :model="dados" ref="form" label-position="top">
      <el-form-item label="Vínculo">
        <el-radio-group v-model="vinculo" @change="trocarVinculo">
          <el-radio label="interno">Servidor da rede</el-radio>
          <el-radio label="externo">Profissional externo / contratado</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- INTERNO: seleciona o servidor; dados pessoais vêm dele e são somente leitura -->
      <div v-if="vinculo === 'interno'">
        <el-alert class="u-mb-20" type="info" :closable="false" show-icon
          title="Os dados pessoais vêm do cadastro do servidor e não são copiados para cá. Para corrigi-los, edite a ficha do servidor."></el-alert>

        <el-form-item label="Servidor" prop="servidor_id">
          <el-select v-model="dados.servidor_id" filterable remote reserve-keyword
                     placeholder="Digite o nome do servidor" :remote-method="buscarServidor"
                     :loading="buscando" style="width:100%" @change="carregarServidor">
            <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
          </el-select>
        </el-form-item>

        <el-row :gutter="10" v-if="servidorSelecionado">
          <el-col :xs="24" :sm="8">
            <el-form-item label="Nome (do cadastro do servidor)">
              <el-input :value="servidorSelecionado.nome" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="CPF (do cadastro do servidor)">
              <el-input :value="servidorSelecionado.cpf" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="E-mail (do cadastro do servidor)">
              <el-input :value="servidorSelecionado.email" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- EXTERNO: dados próprios, porque não existem em nenhum outro cadastro -->
      <div v-else>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="10">
            <el-form-item label="Nome" prop="nome">
              <el-input v-model="dados.nome"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="CPF">
              <el-input v-model="dados.cpf" maxlength="14"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="E-mail">
              <el-input v-model="dados.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Telefone">
          <el-input v-model="dados.telefone" style="max-width:260px"></el-input>
        </el-form-item>
      </div>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="8">
          <el-form-item label="CRN">
            <el-input v-model="dados.crn" placeholder="Registro no conselho"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="4">
          <el-form-item label="UF do CRN">
            <el-input v-model="dados.uf_crn" maxlength="2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6">
          <el-form-item label="Ativo">
            <el-switch v-model="dados.situacao"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="u-text-right u-mt-20">
        <router-link to="/admin/merenda/nutricionista" class="u-mr-10"><el-button>CANCELAR</el-button></router-link>
        <el-button type="primary" @click="salvar">SALVAR</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    id: null,
    vinculo: 'interno',
    buscando: false,
    servidores: [],
    servidorSelecionado: null,
    dados: { servidor_id: '', nome: '', cpf: '', telefone: '', email: '', crn: '', uf_crn: '', situacao: true }
  }),
  mounted () {
    this.id = this.$route.params.id || null
    if (this.id) this.carregar()
  },
  methods: {
    trocarVinculo () {
      // Alternar limpa o que não pertence ao vínculo escolhido — evita enviar dado morto.
      if (this.vinculo === 'interno') {
        this.dados.nome = ''; this.dados.cpf = ''; this.dados.telefone = ''; this.dados.email = ''
      } else {
        this.dados.servidor_id = ''; this.servidorSelecionado = null
      }
    },
    buscarServidor (query) {
      if (!query) { this.servidores = []; return }
      this.buscando = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`, { query: query }, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.servidores = Array.isArray(response.data) ? response.data : (response.data.data || [])
          this.buscando = false
        }).catch(() => { this.buscando = false; this.servidores = [] })
    },
    carregarServidor (id) {
      this.servidorSelecionado = this.servidores.find(s => s.id === id) || null
    },
    carregar () {
      window.eventBus.$emit('loading', true)
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/nutricionista/getById/` + this.id, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.dados = Object.assign(this.dados, response.data)
          this.vinculo = response.data.servidor_id ? 'interno' : 'externo'
          if (response.data.servidor) {
            this.servidorSelecionado = response.data.servidor
            this.servidores = [response.data.servidor]
          }
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    salvar () {
      window.eventBus.$emit('loading', true)
      const url = this.id
        ? `${this.$store.state.config.baseUrlApi}/api/merenda/nutricionista/update/` + this.id
        : `${this.$store.state.config.baseUrlApi}/api/merenda/nutricionista/store`
      this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$router.push('/admin/merenda/nutricionista')
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    }
  }
}
</script>
